import axiosInstance from '../axios'

export function loadCriteriaSearchData() {
    return axiosInstance.get('/request-history/load-criteria-search-data')
}

export function searchRunRequests(criteriaSearch) {
    return axiosInstance.post('/request-history/search', criteriaSearch)
}
